import React, { useRef, useState, useEffect } from 'react'
import { ComboBox } from '@progress/kendo-react-dropdowns';
import LabelPure from '../../../../pures/label/label.pure';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Error, Hint } from '@progress/kendo-react-labels';
import { filterBy } from "@progress/kendo-data-query";

function ComboboxWrapper(fieldRenderProps) {
    const {
        touched,
        label,
        id,
        valid,
        hint,
        validationMessage,
        data: noFilteredData,
        ...others
    } = fieldRenderProps;

    // Kendo functions to filter the combobox
    const [data, setData] = useState([]);

    const setInitialData = () => {
        setData(noFilteredData.slice())
    }

    useEffect(() => {
        if (noFilteredData.length > 0) setInitialData()
    }, [noFilteredData])

    const filterData = (filter) => {
        const data = noFilteredData.slice();
        return filterBy(data, filter);
    };

    const filterChange = (event) => {
        setData(filterData(event.filter));
    };

    const editorRef = useRef(null);
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : "";
    const errorId = showValidationMessage ? `${id}_error` : "";
    const labelId = label ? `${id}_label` : "";

    return (
        <FieldWrapper className={`dropdownWrapper ${showValidationMessage ? "dropdownWrapper-error" : ""}`}>
            <LabelPure
                id={labelId}
                editorId={id}
                className="k-form-label"
                title={label}
            />
            <div className={"k-form-field-wrap"}>
                <ComboBox
                    // ariaLabelledBy={labelId}
                    // ariaDescribedBy={`${hintId} ${errorId}`}
                    ref={editorRef}
                    id={id}
                    // fillMode="flat"
                    // validationMessage={validationMessage}
                    filterable={true}
                    onFilterChange={filterChange}
                    data={data}
                    {...others}
                />
                {showHint && <Hint id={hintId}>{hint}</Hint>}
                {showValidationMessage && (
                    <Error id={errorId}>{validationMessage}</Error>
                )}
            </div>
        </FieldWrapper>
    );
};

export default ComboboxWrapper